var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"float-end",attrs:{"outlined":"","small":"","color":"primary","to":{ path: _vm.pathName }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-plus ")]),_vm._v(" "+_vm._s(_vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }